// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","SearchResults":"jb_a bhb_a bhb_j bhb_q bhb_rp bhb_rq bhb_w"};